import Siema from 'siema';

document.querySelectorAll<HTMLElement>('[data-products]').forEach(products => {
	const slideshow = products.querySelector<HTMLElement>(
		'[data-products-slideshow]',
	);
	const buttons = products.querySelectorAll<HTMLElement>(
		'[data-products-button]',
	);

	if (!slideshow) return;

	const slides = new Siema({
		selector: slideshow,
		draggable:
			'matchMedia' in window ? matchMedia('(hover: none)').matches : false,
		loop: true,
	});

	buttons.forEach((button, i) => {
		button.addEventListener('click', () => {
			slides.goTo(i);
		});
	});
});
